// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"0a7c2e60","186":"27e69535","352":"e6beb09b","444":"a56ae362","560":"40e4c0cc","570":"856dabca","695":"71a462c9","736":"040ad58b","787":"f309dd56"}[chunkId] + ".chunk.js";
};